module.exports = __webpack_public_path__ + "static/media/loc1_img14.2d3c2e7d.jpg";